<template>
  <div class="alert-actions">
    <div class="list-group responsive">
      <div
        v-for="action in categoryResponse.actions"
        :key="action.name"
        class="list-group-item bg-transparent border-0 p-0"
      >
        <div class="row p-3">
          <div class="col d-flex align-items-center pl-0">
            <button
              :disabled="surveyIsCompleted || !userCanSelectAlertActions"
              :class="[
                'btn btn-round me-5 btn-responsive',
                actionValuesMap[action.name]
                  ? 'btn-primary chosen'
                  : 'btn-secondary'
              ]"
              @click="didToggleAction(action)"
            >
              <i
                class="fs-3 p-0"
                :class="
                  actionValuesMap[action.name]
                    ? 'bi-check2-square'
                    : 'bi-square text-dark'
                "
              ></i>
            </button>

            <button
              :disabled="surveyIsCompleted || !userCanSelectAlertActions"
              class="btn btn-link text-start p-0 select-action-button"
              @click="didToggleAction(action)"
            >
              <p class="mb-0 fs-5">
                {{ $tr(action.messages, 'title') }}
              </p>
            </button>
          </div>

          <div class="col-1 d-flex align-items-center justify-content-end">
            <span
              v-if="action.shouldDisplayInfoButton"
              class="icon icon-primary d-flex align-items-center px-4 py-4 cursor-help"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              :title="$tr(action.messages, 'description')"
            >
              <i class="bi bi-info-circle-fill fs-3 text-info"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AlertActions',
  props: {
    categoryName: String,
    // actions: {
    //   type: Array,
    //   default: () => []
    // },
    userCanSelectAlertActions: {
      type: Boolean,
      default: false
    },
    categoryResponse: {
      type: Object,
      default: () => {}
    },
    surveyIsCompleted: {
      type: Boolean,
      default: false
    },
    updateAlertActionResponse: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      unconfirmedActions: {}
    }
  },
  computed: {
    actionValuesMap() {
      const map = {}
      const actions = this.categoryResponse?.actions || []
      for (const a of actions) {
        map[a.name] = Object.prototype.hasOwnProperty.call(
          this.unconfirmedActions,
          a.name
        )
          ? this.unconfirmedActions[a.name]
          : a.value
      }
      return map
    }
  },
  watch: {
    categoryResponse() {
      this.categoryResponse.actions?.forEach((a) => {
        if (this.unconfirmedActions.hasOwnProperty(a.name)) {
          const { [a.name]: removed, ...rest } = this.unconfirmedActions
          this.unconfirmedActions = rest
        }
      })
    }
  },
  mounted() {},
  methods: {
    didToggleAction(action) {
      const updatesCategoryResponse = {
        ...this.categoryResponse,
        actions: this.categoryResponse.actions.map((a) => {
          if (a.name === action.name) {
            const next = !a.value
            this.unconfirmedActions = {
              ...this.unconfirmedActions,
              [a.name]: next
            }
            return { ...a, value: next }
          }
          return a
        })
      }

      this.updateAlertActionResponse({
        action,
        categoryResponse: updatesCategoryResponse
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.select-action-button:hover {
  color: var(--kt-primary);
}
</style>
